import React, { useState, useRef } from "react";
import { useDispatch } from "react-redux";
import { Link, useHistory } from "react-router-dom";
import _ from "lodash";

import { InputText } from "primereact/inputtext";

import { getProjectPmAction } from "../../../../../redux/action/projectAction";
import filterIcon from "../../../../assets/img/Filter-2.png";
import sortIcon from "../../../../assets/img/Filter.png";
import PopupFilterListProject from "./PopupFilterListProject";
import PopupSortProject from "./PopupSortProject";

const FilterListProject = (props) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const [showPopupFilter, setShowPopupFilter] = useState(false);
  const [showPopupSort, setShowPopupSort] = useState(false);
  const { parsed } = props;

  const searchingHandler = useRef(
    _.debounce((search) => {
      const params = {
        q: search,
        category: parsed?.category || "",
        type: parsed?.type || "",
        orderField: parsed?.order || "",
        orderDir: parsed?.order === "createdAt" ? "desc" : "asc",
        page: 1,
        perpage: 10,
      };

      history.push(
        `/admin/pm/list-project?search=${search}&type=${parsed?.type ||
          ""}&category=${parsed?.category || ""}&order=${parsed?.order ||
          ""}&page=1`
      );
      dispatch(getProjectPmAction(params));
    }, 1000)
  ).current;

  const handleClickFilter = () => {
    setShowPopupFilter(!showPopupFilter);
    setShowPopupSort(false);
  };

  const handleClickSort = () => {
    setShowPopupSort(!showPopupSort);
    setShowPopupFilter(false);
  };

  return (
    <div className="p-d-flex p-jc-between p-mb-3">
      <div className="search-list-project">
        <div className="d-flex">
          <InputText
            id="search"
            aria-describedby="search-help"
            className="p-d-block"
            placeholder="Cari"
            onChange={(e) => searchingHandler(e.target.value)}
          />
          <button onClick={handleClickFilter}>
            <img src={filterIcon} alt="filter" />
          </button>
          <button onClick={handleClickSort}>
            <img src={sortIcon} alt="filter" />
          </button>
        </div>
        <p>
          Cari berdasarkan<span> Nama Project</span>
        </p>
      </div>
      <Link
        to="/admin/pm/add-project"
        className="p-button p-button-primary button-link"
      >
        Tambah Project
      </Link>
      <PopupFilterListProject
        show={showPopupFilter}
        onHide={() => setShowPopupFilter(false)}
        parsed={parsed}
      />
      <PopupSortProject
        show={showPopupSort}
        onHide={() => setShowPopupSort(false)}
        parsed={parsed}
      />
    </div>
  );
};

export default FilterListProject;
